"use strict";
'use strict';

var table = require('./table.cjs');



exports.Body = table.TableBody;
exports.Caption = table.TableCaption;
exports.Cell = table.TableCell;
exports.Column = table.TableColumn;
exports.ColumnGroup = table.TableColumnGroup;
exports.ColumnHeader = table.TableColumnHeader;
exports.Footer = table.TableFooter;
exports.Header = table.TableHeader;
exports.Root = table.TableRoot;
exports.RootPropsProvider = table.TableRootPropsProvider;
exports.Row = table.TableRow;
exports.ScrollArea = table.TableScrollArea;
